import React from 'react';
import PropTypes from 'prop-types';
import HeaderSection from '../components/HeaderSection';
import InfoSection from '../components/InfoSection';
import ButtonDefaultSection from '../components/ButtonDefaultSection';

const Default = ({ label, labelBtn, onToggle, infoPin }) => (
  <div>
    <HeaderSection labelTitle={label.title} labelSubtitle={label.subTitle} />

    <div className="padding-top-1">
      <InfoSection
        className="row"
        enable={infoPin.pinParental}
        text={infoPin.pinParentalInfo && infoPin.pinParentalInfo.name}
        labelTitle={label.controlPin.title}
        labelDescription={
          infoPin.pinParental
            ? label.controlPin.description
            : label.controlPin.descriptionOff
        }
      />
      <InfoSection
        className="row"
        enable={infoPin.pinPurchase}
        labelTitle={label.paymentProtection.title}
        labelDescription={
          infoPin.pinPurchase
            ? label.paymentProtection.description
            : label.paymentProtection.descriptionOff
        }
      />
    </div>
    <ButtonDefaultSection
      labelDesactive={labelBtn.btnDesactive}
      labelChange={labelBtn.btnChange}
      labelRemind={labelBtn.btnRemind}
      labelModify={labelBtn.btnModify}
      onToggle={onToggle}
    />
  </div>
);

Default.propTypes = {
  infoPin: PropTypes.object,
  label: PropTypes.object,
  labelBtn: PropTypes.object,
  onToggle: PropTypes.func,
};
export default Default;
